<template>
  <modal title="Soft Limit Reached Modal" ref="softLimitModal" id="soft-limit-reached-modal" class="mt-4" :hide-header="true" :hide-footer="true">
    <button type="button" class="close" @click="close">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="view-only-content justify-content-md-center text-center mt-4">
      <div class="title dark-gray-txt mb-3"><strong>50 items limit reached</strong></div>
      <img class="icon" src="@img/icons-card-actions-compact-read-only.svg">
      <p class="mt-3 dark-gray-txt body">
        This content is still viewable but we will soon enforce this limit.
        Upgrade to get unlimited videos and screenshots!
      </p>
      <div class="mt-4 mb-4">
        <a :href="btnHref" class="btn-upgrade" data-testid="50-limit-modal-upgrade">
          Upgrade
        </a>
      </div>
    </div>
  </modal>
</template>

<script>

import Modal from '@/src/components/modal.vue';

export default {
  components: { Modal },
  mounted() { this.$refs.softLimitModal.$refs.modal.show() },
  methods: {
    close: function() { this.$refs.softLimitModal.$refs.modal.hide() }
  },
  computed: {
    btnHref: function() {
      var utmMedium = this.$route.path == "/dashboard" ? "dashboard" : "viewer";
      return `/plans?utm_campaign=50dropslimitsoft&utm_source=modal&utm_medium=${utmMedium}`;
    }
  }
}
</script>

<style lang="scss">
  #soft-limit-reached-modal {
    .modal-md { padding: 4rem; }
    .title {
      font-weight: 600;
      font-size: 24px;
    }
    .dark-gray-txt { color: #4A4A4A; }
    .body { 
      margin: 1.563rem 0 1.25rem;
      font-family: SFPro;
      font-size: 1rem;
    }
    .btn-upgrade {
      color: white;
      font-family: SFPro;
      font-size: 0.875rem;
      font-weight: bold;
      margin: 1.25rem 2.188rem 0;
      padding: 0.625rem 1.25rem 0.625rem 1.375rem;
      border-radius: 5px;
      background-image: linear-gradient(99deg, #f09819 14%, #ff5858 99%);

      &:hover {
        color: white;
        text-decoration: none;
      }
    }
  }
</style>
